module.exports = __webpack_public_path__ + "img/huanjing_01.7307cfa3.jpg";